export default __webpack_public_path__ + "static/media/shipit.fa3c6a5c.svg";